<template>
  <v-card outlined tile>
    <v-card-title class="headline">
      <v-chip :class="value.panelStatus ? 'success' : 'primary'" dark label>
        <v-icon left small v-if="value.panelStatus"> mdi-check </v-icon>
        <v-icon left small v-else> mdi-pause </v-icon>
        {{ value.panelStatusText || "Banner status N/A" }}
      </v-chip>
      <v-btn
        class="primary"
        tile
        text
        right
        absolute
        id="delete-link"
        @click="deleteFormat"
        ><v-icon small left> mdi-delete </v-icon>Delete</v-btn
      >
    </v-card-title>
    <v-card-text>
      
      <v-text-field
        label="Dimension (WIDTHxHEIGHT)"
        v-model="value.dimensions"
        :rules="dimensionsRules"
        required
      ></v-text-field>
      <v-text-field
        label="Banner hash"
        v-model="value.hash"
        @change="getBannerData"
      ></v-text-field>
      <v-text-field
        label="Banner live"
        v-model.lazy="value.live"
        readonly
        @change="getBannerData"
      ></v-text-field>
      <v-file-input
        v-model="value.file"
        placeholder="Upload mockup"
        label="File input"
        prepend-icon="mdi-paperclip"
        show-size
        name="file"
      >
        <template v-slot:selection="{ text }">
          <v-chip label color="primary">{{ text }}</v-chip>
        </template>
      </v-file-input>
    </v-card-text>
    <!-- </div> -->
    <v-list-item two-line v-if="imgUrl" class="mx-2">
      <v-list-item-content>
        <v-list-item-title>IMG {{ value.file }}</v-list-item-title>
        <v-list-item-subtitle>
          <v-img
            v-if="imgUrl"
            :src="imgUrl"
            :width="value.dimensions.split('x')[0]"
            :height="value.dimensions.split('x')[1]"
            max-height="600"
            contain
            position="left"
          />
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line class="mx-2">
      <v-list-item-content>
        <v-list-item-title>Live</v-list-item-title>
        <v-list-item-subtitle style="overflow: auto">
          <iframe
            sandbox="allow-scripts allow-same-origin allow-top-navigation"
            v-format-preview="value.live"
            frameborder="0"
            :width="width"
            :height="height"
            class="live-preview"
            ref="iframe"
          ></iframe>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
// import axios from "axios";
import PreviewService from "@/common/services/preview";

export default {
  name: "BannerAdditionalFormat",
  data() {
    return {
      dimensionsRules: [
        v => !!v || "Dimensions are required",
        v => /^(\d)+(x|X)(\d)+$/.test(v) || "Dimensions must be valid"
      ]
    };
  },
  computed: {
    width() {
      if (this.value.dimensions) {
        return this.value.dimensions.split("x")[0];
      }
      return 0;
    },
    height() {
      if (this.value.dimensions) {
        return this.value.dimensions.split("x")[1];
      }
      return 0;
    },
    imgUrl() {
      // if (typeof this.value.file === "string")
      //   return `${process.env.VUE_APP_PUBLIC_URL}` + this.value.fileName;
      // const file = this.value.file;
      // if (file) return URL.createObjectURL(file);
      // return null;

      if (this.value.file) return URL.createObjectURL(this.value.file);
      if (typeof this.value.fileName === "string")
        return `${process.env.VUE_APP_PUBLIC_URL}` + this.value.fileName;
      return null;
    }
  },
  props: ["value", "offers", "subcampaigns"],
  methods: {
    deleteFormat() {
      this.$emit("delete");
    },
    updateModel() {
      this.$emit("input", this.value);
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.value.file = file;
    },
    async getBannerData() {
      if (this.value.hash) {
        try {
          const { offers, subcampaigns } = this;
          const { data } = await PreviewService.getBannersPreview({
            hash: this.value.hash,
            offers,
            subcampaigns
          });

          const bannerData = data[0];

          if (bannerData.previewUrl.includes("/api/render/video/")) {
            this.value.dimensions = "600x380";
            bannerData.width = 600;
            bannerData.height = 380;
          }
          this.value.dimensions =
            this.value.dimensions || `${bannerData.width}x${bannerData.height}`;
            

          this.value.live = bannerData.previewUrl;
          this.value.panelStatusText = bannerData.status;
          this.value.panelStatus =
            bannerData.status.toLowerCase() == "active" ? true : false;
          this.updateModel();
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  mounted() {
    this.getBannerData();
  }
};
</script>

<style>
</style>